import React from 'react';
import routes from 'js/core_pre_webpack/routes';

import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import UserSentimentPopup from 'js/liswp/UserSentimentPopup';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

function onSubmit(sentiment: number, explanation: string) {
  fetchWithCsrf(
    routes.api_v0_user_courses_sentiments_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sentiment, explanation }),
    },
  );
}

export const userSentimentPopup = (
  <ImpressionWatcher source="user_courses_sentiment_popup">
    <UserSentimentPopup
      question="Are you finding the Course you’re looking for?"
      onSubmit={onSubmit}
      whyNo={true}
      reasonPlaceholder="Can you tell us what you’re looking for..."
    />
  </ImpressionWatcher>
);
